import { render } from "./ManageInstances.vue?vue&type=template&id=8e254e06"
import script from "./ManageInstances.vue?vue&type=script&lang=js"
export * from "./ManageInstances.vue?vue&type=script&lang=js"
script.render = render

export default script